import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { MILESTONE_DEFINITIONS_ACTION_TYPE } from '../actions';

const initialState = [];

const externalCrmMilestonesReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case MILESTONE_DEFINITIONS_ACTION_TYPE.GET_EXTERNAL_CRM_MILESTONES:
        return payload;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default externalCrmMilestonesReducer;
